import apiClient from '@utils/apiClient';
import {
    DashboardFarmlandMapItem,
    DashboardFarmlandMapRes,
    DashboardStat,
    DashboardStatRes,
    DashboardWeather,
    DashboardWeatherRes,
} from './type';
import { CorporationInfo, CorporationInfoRes } from '@/api/corporation/type';

export const api = {
    /**
     * 대시보드 전체 통계 조회
     * @param userIdx 대행사번호
     */
    dashboardStat: async (): Promise<DashboardStat> => {
        const response = await apiClient.get<DashboardStatRes>(
            `/api/v1/dashboard/statis`,
        );
        return response.data.data;
    },

    /**
     * 대행사상세
     * @param userIdx
     */
    corporationInfo: async (): Promise<CorporationInfo> => {
        const response = await apiClient.get<CorporationInfoRes>(
            `/api/v1/dashboard/info`,
        );
        return response.data.data;
    },

    /**
     * 대시보드 날씨정보
     */
    dashboardWeather: async (): Promise<DashboardWeather> => {
        const response = await apiClient.get<DashboardWeatherRes>(
            `/api/v1/dashboard/weather`,
        );
        return response.data.data;
    },

    /**
     * 대시보드 농지목록
     */
    dashboardFarmlandMapList: async (): Promise<DashboardFarmlandMapItem[]> => {
        const response = await apiClient.get<DashboardFarmlandMapRes>(
            `/api/v1/dashboard/farmland-map`,
        );
        return response.data.data;
    },
};
